import { create } from 'axios'
import { events } from './useEvents'
// import { BACKEND_ERROR_STRING } from '@/constants/VALIDATIONS'
import extend from 'just-extend'

const axios = create({
  baseURL: '/api',
})

const axiosDataJson = function (res) {
  if (typeof res.data === 'object') {
    return res
  }
  let resData = res.data || res
  if (typeof resData === 'string') {
    try {
      resData = JSON.parse(resData)
    } catch (e) {
      /* Nothing */
    }
  } else {
    resData = resData.body || resData
    if (typeof resData === 'string') {
      try {
        resData = JSON.parse(resData)
      } catch (e) {
        /* Nothing */
      }
    }
  }
  if (typeof resData === 'object') {
    return Object.assign({}, res, { data: resData })
  }
  return res
}

const removeBodySubmitting = () => {
  if (typeof window === 'undefined') return
  clearTimeout(window.BODY_CLASS_SUBMITTING_TIMEOUT)
  window.BODY_CLASS_SUBMITTING_TIMEOUT = setTimeout(() => {
    document.body.classList.remove('submitting')
  }, 360)
}

const addBodySubmitting = () => {
  if (typeof window === 'undefined') return
  document.body.classList.add('submitting')
}

axios.interceptors.request.use(
  config => {
    addBodySubmitting()
    return config
  },
  error => {
    removeBodySubmitting()
    events.$emit('axios-error', error)
    events.$emit('api-error', error)
    return Promise.reject(error)
  },
)

// @TODO: Test deze logica (backend errors formulieren) wanneer geimplementeerd in cloudplatform
const backendErrorsHandler = () => {
  /* (res, _parsed = null) => {
  /*
  const parsed = typeof _parsed === 'object' ? _parsed : axiosDataJson(res)
  if (!parsed.success && parsed.error === BACKEND_ERROR_STRING) {
    Object.entries(parsed.data).forEach(([fieldName, errors]) => {
      events.$emit(`validation-error-${fieldName}`, errors)
    })
  }
  */
}

axios.interceptors.response.use(
  res => {
    removeBodySubmitting()
    events.$emit('axios-response', res)
    events.$emit('api-response', res)
    const parsed = axiosDataJson(res)
    const { redirect } = parsed.data || {}
    if (redirect) {
      /**
       * @TODO: In commentaar!
       * Tot we volledig alles in Vue hebben
       * Zodat internal routing gebeurt eenmaal overgezet -> sneller voor gebruiker
       */
      // if (redirect[0] === '/') {
      //     const router = useRouter()
      //     router.push(parsed.data.redirect)
      // } else {
      window.location.href = redirect
      // }
    }
    return parsed
  },
  error => {
    if (error?.response?.status === 401) {
      window.location.href = '/login?status=401'
    }
    removeBodySubmitting()
    backendErrorsHandler(error.response)
    events.$emit('axios-error', error)
    events.$emit('api-error', error)
    if (typeof window?.alert !== 'undefined') {
      if (error?.response?.data?.validationErrors?.length) {
        window.alert(error.response.data.validationErrors.map(el => el.error).join('\n'))
      } else if (error?.response?.data?.error) {
        window.alert(error.response.data.error)
      } else {
        window.alert(
          typeof error.toString === 'function' ? error.toString() : error.error || error.message || error.err || error,
        )
      }
    }
    return Promise.reject(error)
  },
)

const generateDocValues = (type, values = {}) => extend({ type }, values)
const generateDocApi = type => ({
  create: values => axios.post('/docs/add', generateDocValues(type, values)),
  list: values => axios.get('/docs/list', { params: generateDocValues(type, values) }),
  get: values => axios.get('/docs/info', { params: generateDocValues(type, values) }),
})

export default () => ({
  clients: {
    create: values => axios.post('/clients/add', values),
    edit: values => axios.patch('/clients/edit', values),
    list: values => axios.get('/clients/list', { params: values }),
    get: values => axios.get('/clients/info', { params: values }),
    search: search => axios.get('/clients/search', { params: { search } }),
  },
  products: {
    create: values => axios.post('/products/add', values),
    edit: values => axios.patch('/products/edit', values),
    list: values => axios.get('/products/list', { params: values }),
    get: values => axios.get('/products/info', { params: values }),
    search: search => axios.get('/products/search', { params: { search } }),
  },
  quotes: Object.assign({
    toAcompte: values => axios.post('/docs/to-acompte', values),
    toInvoice: values => axios.post('/docs/to-invoice', values),
    toProduction: values => axios.patch('/docs/to-production', values),
    edit: values => axios.patch('/docs/edit', generateDocValues('QUOTE', values)),
    ...generateDocApi('QUOTE'),
  }),
  invoices: Object.assign({
    ...generateDocApi('INVOICE'),
    addPayment: values => axios.post('/payments/add', values),
    removePayment: values => axios.delete('/payments/remove', { params: values }),
    toProduction: values => axios.patch('/docs/to-production', values),
    edit: values => axios.patch('/docs/edit', generateDocValues('INVOICE', values)),
    remove: values => axios.delete('/invoices/remove', { params: generateDocValues('INVOICE', values) }),
  }),
  'credit-notes': generateDocApi('CREDIT_NOTE'),
  creditNotes: generateDocApi('CREDIT_NOTE'),
  production: {
    setStatus: values => axios.patch('/production/status', values),
    setStage: values => axios.patch('/production/stage', values),
    setDescription: values => axios.patch('/production/description', values),
    ...generateDocApi('PRODUCTION'),
  },
  docs: generateDocApi('DOC'),
  stats: {
    list: values => axios.get('/stats/list', { params: values }),
    counters: () => axios.get('/stats/counters'),
  },
  files: {
    list: values => axios.get('/files/list', { params: values }),
    remove: values => axios.delete('/files/remove', { params: values }),
  },
  auth: {
    id: values => axios.get('/auth/id', { params: values }),
    profile: values => axios.get('/auth/profile', { params: values }),
    login: values => axios.post('/auth/login', values),
    logout: values => axios.post('/auth/logout', values),
    passwordChange: values => axios.patch('/auth/password-change', values),
  },
  axios,
})
